<div id="footer"><p v-if="!isDemoUser">{{ $t('footer.copyright', { year: currentYear }) }}</p></div>